import React, { useState, useEffect, useRef } from 'react';
import '../../spinner.css';
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { getNextModuleFromService, getPrevModuleFromService } from '../ModuleService';
import { getPedagogy } from '../../services/CourseService';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import moment from 'moment';
import Vimeo from '@u-wave/react-vimeo';
import { getDateText } from '../../services/Utils';
import { toast } from 'react-toastify';
import { getNotes, addNotes, updateNotes, getVimeoSubtitles, addOrUpdateFeedback, getUserLikenesss } from '../../services/LearningService';
import { postLearning } from '../../services/LearningService';
import Loader from '../../utility/Loader';
import '../learnings/accordion.css'
import jsPDF from 'jspdf';
import { getActiveSurveyQuestionWithId, addSurveyAnswer } from '../../services/Survey';
import SurveyPopup from './SurveyPopup';

export default function LearnerVideo() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [module, setModule] = useState({});
    const [pedagogy, setPedagogy] = useState([]);
    const [shakeActive, setShakeActive] = useState(true);
    const [selectedPedagogyIndex, setSelectedPedagogyIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPedagogy, setSelectedPedagogy] = useState({});
    const [topics, setTopics] = useState([]);
    const [notes, setNotes] = useState([]);
    const [selectedNote, setSelectedNote] = useState({ notes: "" });
    const [startTs, setStartTs] = useState(null);
    const [transcript, setTranscript] = useState([]);
    const [viewMode, setViewMode] = useState("list");
    const [feedback, setFeedback] = useState("");
    const [popupVisible, setPopupVisible] = useState(false);
    const [resolvePopup, setResolvePopup] = useState(null);
    const [allSurvey, setAllSurvey] = useState([]);
    const [showFeedback, setShowFeedback] = useState(false);
    const feedbackRef = useRef(null);
    const [selectedFeedback, setSelectedFeedback] = useState(null);


    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {

            let moduleSelected = sessionStorage.getItem('currentModule') !== undefined ? JSON.parse(sessionStorage.getItem('currentModule')) : {};
            setModule(moduleSelected);
            const isAlreadySentHi = sessionStorage.getItem('qBotHi');
            if (isAlreadySentHi === undefined || isAlreadySentHi === null || isAlreadySentHi !== userDetails.user.first_name) {
                const dfMessenger = document.querySelector('df-messenger');
                dfMessenger.renderCustomText('Hello ' + userDetails.user.first_name + ', I am your friendly assistant. Let us make your learning journey seamless and enjoyable! Just type your question, and I will provide you with the information you need. Happy learning!', true);
                sessionStorage.setItem('qBotHi', userDetails.user.first_name);
            }
            let pedagogySelected = sessionStorage.getItem('currentPedagogy') !== undefined ? JSON.parse(sessionStorage.getItem('currentPedagogy')) : {};
            if (pedagogySelected !== null && pedagogySelected.index !== undefined && pedagogySelected.index !== null) {
                moduleSelected["pedagogy_id"] = pedagogySelected.id;
                sessionStorage.removeItem('currentPedagogy');

            }
            getAllPedagogy(userDetails.token, moduleSelected);
        }
    }, []);

    useEffect(() => {
        if (showFeedback) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showFeedback]);

    const getAllPedagogy = async (token, moduleSelected) => {
        const userDetails = getUserDetails();
        let all = await getPedagogy(token, moduleSelected.module_id);
        setPedagogy(all.data);
        if (all.data.length > 0) {
            let index = 0;
            if (moduleSelected.pedagogy_id !== undefined && moduleSelected.pedagogy_id !== null) {
                for (let i = 0; i < all.data.length; i++) {
                    if (all.data[i].pedagogy_type === 'VIDEO') {
                        index = i;
                    }
                    if (all.data[i].id === moduleSelected.pedagogy_id) {
                        if (all.data[i].pedagogy_type === 'VIDEO') {
                            index = i;
                        }
                        if (all.data[i].pedagogy_type === 'ASSESSMENT' && i + 1 < all.data.length) {
                            index = i + 1;
                        }
                        break;
                    }
                }
            }

            setSelectedPedagogyIndex(index);

            setSelectedPedagogy(all.data[index]);
            await getVimeoSubtitleData(all.data[index])
            setStartTs(moment.utc());
            await getAllNotes(all.data[index].id);
            if (all.data[index].tags !== undefined && all.data[index].tags !== null) {
                setTopics(all.data[index].tags.split(","));
            }
        }
    };

    const getAllNotes = async (pedagogy_id) => {
        const userDetails = getUserDetails();
        let resp = await getNotes(userDetails.token, pedagogy_id);
        if (resp["error"] === false) {
            setNotes(resp.data);
        } else {
            // toast.error("Some error occurred while adding note!");
        }

    };

    const showPopup = () => {
        return new Promise((resolve) => {
            setResolvePopup(() => resolve);
            setPopupVisible(true);
        });
    };

    const handleClose = (value) => {
        setPopupVisible(false);
        setAllSurvey([]);
        if (resolvePopup) {
            resolvePopup(value);
            setResolvePopup(null);
        }
    };

    const getActiveSurveyQuestionWithIdData = async () => {
        const userDetails = getUserDetails();

        let module_id = module.module_id;
        let resp = await getActiveSurveyQuestionWithId(userDetails.token, "module_id", module_id);
        if (resp.error === false && resp.data.length > 0) {
            setAllSurvey(resp.data);
            const inputValue = await showPopup();
            if (inputValue.length > 0) {
                let allObj = [];
                for (let i = 0; i < inputValue.length; i++) {
                    allObj.push({ survey_id: inputValue[i].id, user_id: userDetails.user.id, customer_id: userDetails.user.customer_id, user_answer: inputValue[i].answer, cohort_id: userDetails.user.cohort_id });
                }
                let resp1 = await addSurveyAnswer(userDetails.token, allObj);
                if (resp1.error === false) {
                    toast.success("Thank you for your feedback");
                } else {
                    toast.error("Some error occurred while recording your feedback");
                }
            }
        }
    };

    const changeModule = async (changeType) => {
        const userDetails = getUserDetails();
        let nextModule = {};
        await addLearning();
        await getActiveSurveyQuestionWithIdData();
        if (changeType === "next") {
            nextModule = await getNextModuleFromService(module);

        } else {
            nextModule = await getPrevModuleFromService(module);
        }
        if (nextModule["module_type"] === undefined) {
            navigate('/learner/courses');
        }
        if (nextModule.module_type === module.module_type) {
            await getAllPedagogy(userDetails.token, nextModule);
            setModule(nextModule);
            sessionStorage.setItem('currentModule', JSON.stringify(nextModule));
            return;
        }

        if (nextModule.module_type === "THEORY") {
            navigate('/learner/video');
        } else if (nextModule.module_type === "GAME") {
            navigate('/learner/game');
        } else if (nextModule.module_type === "ASSESSMENT") {
            navigate('/learner/assessment');
        } else {
            navigate('/learner/courses');
        }
    };

    const toggleMenu = () => {
        setIsOpen(prev => !prev);
    };

    const changePedagogy = async (index) => {
        addLearning();
        setSelectedPedagogyIndex(index);
        setSelectedPedagogy(pedagogy[index]);
        if (pedagogy[index]["pedagogy_type"] === 'ASSESSMENT') {
            let obj = Object.assign(pedagogy[index]);
            obj['index'] = index;
            sessionStorage.setItem('currentModule', JSON.stringify(module));
            sessionStorage.setItem('currentPedagogy', JSON.stringify(obj));

            navigate('/learner/kc');
            return;
        }

        await getVimeoSubtitleData(pedagogy[index])
        await getAllNotes(pedagogy[index].id);
        if (pedagogy[index].tags !== undefined && pedagogy[index].tags !== null) {
            setTopics(pedagogy[index].tags.split(","));
        }
    };

    const addLearning = async () => {
        if (pedagogy.length > 0) {
            let currentTs = moment.utc();
            let secs = currentTs.diff(startTs, "seconds");
            setStartTs(currentTs);
            const userDetails = getUserDetails();
            let objectToSend = { module_id: module.module_id, pedagogy_id: selectedPedagogy.id, learning_sec: secs, cohort_id: userDetails.user.cohort_id };
            const resp = await postLearning(userDetails.token, objectToSend);
            if (resp.error) {
            }
        }

    };

    const handleVideoEnd = async () => {
        if (selectedPedagogyIndex === pedagogy.length - 1) {
            toast.info("No more video!");
        } else {
            await changePedagogy(selectedPedagogyIndex + 1);
        }
    };

    const addNote = async () => {
        const userDetails = getUserDetails();
        let obj = { course_id: module.course_id, module_id: module.module_id, pedagogy_id: selectedPedagogy.id, cohort_id: userDetails.user.cohort_id, notes: selectedNote.notes }
        let resp = await addNotes(userDetails.token, obj);
        if (resp["error"] === false) {
            toast.success("Node added!");
            setSelectedNote({ notes: "" });
            await getAllNotes(selectedPedagogy.id);
        } else {
            toast.error("Some error occurred while adding note!");
        }
    };

    const handleValueChange = (e) => {

        const { name, value } = e.target;
        setSelectedNote({
            ...selectedNote,
            [name]: value,
        });
    };

    const extractVimeoId = async (url) => {
        const match = url.match(/vimeo\.com\/(\d+)/);
        return match ? match[1] : null;
    };

    const getVimeoSubtitleData = async (pedagogy) => {
        const video_id = await extractVimeoId(pedagogy.url);

        const userDetails = getUserDetails();
        let resp = await getVimeoSubtitles(userDetails.token, video_id);

        if (resp["error"] === false) {
            setTranscript(resp.data);
        } else {
            // toast.error("Some error occurred while adding note!");
        }
        await getFeedback(pedagogy);

    };

    const getFeedback = async (pedagogy) => {
        const userDetails = getUserDetails();
        if (pedagogy.id !== undefined && pedagogy.id !== null) {
            let resp = await getUserLikenesss(userDetails.token, pedagogy.id);

            if (resp["error"] === false && resp.data.length > 0) {
                let data = resp.data[0];
                if (data.likeness === true) {
                    setSelectedFeedback('likeness');
                } else if (data.dislikeness === true) {
                    setSelectedFeedback('dislikeness');
                }

            } else {
                setSelectedFeedback(null);
            }
        } else {
            setSelectedFeedback(null);
        }
    };

    const downloadSubtitle = async (link, lang, i) => {
        const response = await fetch(link);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${selectedPedagogy.title}_${i}_${lang}.vtt`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const changeViewMode = async (type) => {
        setViewMode(type);
        if (type === 'thumbnail') {
            navigate('/learner/theory');
        }
    };

    const handleClickOutside = (event) => {
        if (feedbackRef.current && !feedbackRef.current.contains(event.target)) {
            setShowFeedback(false);
        }
    };

    const addFeeback = async (type) => {
        if (type !== 'feedback') {
            setSelectedFeedback(type);
        }
        let obj = {};
        if (type === 'likeness') {
            obj = { type: 'likeness', data: true, pedagogy_id: selectedPedagogy.id, module_id: selectedPedagogy.module_id }
        } else if (type === 'dislikeness') {
            obj = { type: 'dislikeness', data: true, pedagogy_id: selectedPedagogy.id, module_id: selectedPedagogy.module_id }
        } else if (type === 'feedback') {
            obj = { type: 'feedback', data: feedback, pedagogy_id: selectedPedagogy.id, module_id: selectedPedagogy.module_id }
            setFeedback('');
        }
        if (obj['type'] !== undefined && obj['type'] !== null) {
            const userDetails = getUserDetails();
            obj['cohort_id'] = userDetails.user.cohort_id;
            let resp = await addOrUpdateFeedback(userDetails.token, obj);
            if (resp.error === false) {
                // toast.info("Feedback taken successfully!");
            } else {
                toast.error("Some Error occurred! Please try again after some time");
            }
        }
    };

    const handleFeedbackChange = (e) => {
        const { name, value } = e.target;
        setFeedback(value);
    };

    return (
        <>
            <div>
                {loading ? (
                    <Loader />
                ) : (
                    <div className='py-10'>
                        <div className='lg:px-12 px-6 lg:pb-2 pb-1 md:border-b-2 md:border-[#D0D0D0]'>
                            <h3 className='text-2xl text-secondary inter-700 mb-3 lg:hidden'>{module.course_name}</h3>
                            <div className='beardcrumb-wrap mb-5'>
                                <ul className='flex flex-wrap items-center'>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>My Courses</a>
                                    </li>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>{module.course_name}</a>
                                    </li>
                                    <li className='current-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        Lesson {module.module_seq_no}
                                    </li>
                                </ul>
                            </div>
                            <div className='course-heading-wrap lg:mb-6 mb-5 flex items-center justify-between'>
                                {/* <h3 className='text-tertiary text-xl lg:text-2xl inter-500 mb-1'>Lesson {module.module_seq_no}</h3> */}
                                <h2 className='text-[#1D548D] text-2xl inter-500'>{module.module_desc}</h2>
                                <div className="course-video-toggle flex items-center bg-[#D0D0D0] rounded-lg">
                                    <button onClick={() => changeViewMode('thumbnail')} title="Switch to Grid View" className={`grid-view w-10 h-10 cursor-pointer flex items-center justify-center rounded-lg ${viewMode === 'thumbnail' ? 'bg-secondary thumb-selected' : 'bg-[#D0D0D0]'}`} aria-label='grid view video' tabIndex={0}>
                                        <svg fill="#000000" width="20px" height="20px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="clr-i-solid clr-i-solid-path-1" x="4" y="4" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-2" x="20" y="4" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-3" x="4" y="20" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-4" x="20" y="20" width="12" height="12" rx="2" ry="2"></rect>
                                            <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
                                        </svg>
                                    </button>
                                    <button onClick={() => changeViewMode('list')} title="Switch to List View" className={`list-view w-10 h-10 cursor-pointer flex items-center justify-center rounded-lg ${viewMode === 'list' ? 'bg-secondary list-selected' : 'bg-[#D0D0D0]'}`} aria-label='list view video' tabIndex={0}>
                                        <svg width="20px" height="20px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m 2 1 c -0.554688 0 -1 0.445312 -1 1 v 2 c 0 0.554688 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.445312 1 -1 v -2 c 0 -0.554688 -0.445312 -1 -1 -1 z m 5 1 v 2 h 8 v -2 z m -5 4.015625 c -0.554688 0 -1 0.445313 -1 1 v 1.980469 c 0 0.550781 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.449219 1 -1 v -1.980469 c 0 -0.554687 -0.445312 -1 -1 -1 z m 5 0.984375 v 2 h 8 v -2 z m -5 4 c -0.554688 0 -1 0.445312 -1 1 v 1.980469 c 0 0.550781 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.449219 1 -1 v -1.980469 c 0 -0.554688 -0.445312 -1 -1 -1 z m 5 0.984375 v 2 h 8 v -2 z m 0 0" fill="#2e3436" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                        </div>

                        <div className="list-view-video">
                            <div className='course-vdo-wrap lg:pt-10 pt-0 lg:px-12 px-0 pb-8'>
                                <div className='course-vdo-list-row flex flex-wrap'>
                                    <div className='course-vdo-box w-full lg:w-[70%]'>
                                        <div className='video-box w-full bg-black'>
                                            {(selectedPedagogy.transcript !== undefined) ? (
                                                <Vimeo
                                                    key={selectedPedagogy.url}
                                                    video={selectedPedagogy.url}
                                                    width={640}
                                                    height={360}
                                                    responsive
                                                    onEnd={handleVideoEnd}
                                                    autoplay
                                                    dnt={true}
                                                    params={{
                                                        title: 0,
                                                        byline: 0,
                                                        portrait: 0,
                                                    }}
                                                />
                                            ) : (
                                                null
                                            )}


                                        </div>
                                    </div>
                                    <div className='course-vdo-list-wrap w-full lg:w-[30%] bg-black p-8'>
                                        <div className='crse-vdo-list-hdng pb-4 border-b border-[#B9B9B9] flex items-center justify-between'>
                                            <p className='text-2xl text-white'>Course List</p>
                                            <button type='button' className='crse-vdo-list-icon w-[30px] h-[30px] relative outline-none' onClick={toggleMenu} aria-label='video list menu' tabIndex={0}>
                                                <span className={`crse-vdo-list-ham transition-all duration-300 ease-in-out transform absolute top-1/2 left-0 -translate-y-1/2 ${isOpen ? 'opacity-0 scale-90 pointer-events-none' : 'opacity-100 scale-100'}`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="23" viewBox="0 0 31 23" fill="none">
                                                        <path d="M9.62532 0.21875C8.81416 0.21875 8.15657 0.876339 8.15657 1.6875C8.15657 2.49866 8.81416 3.15625 9.62532 3.15625V0.21875ZM29.2087 3.15625C30.0198 3.15625 30.6774 2.49866 30.6774 1.6875C30.6774 0.876339 30.0198 0.21875 29.2087 0.21875V3.15625ZM1.79199 0.21875C0.980831 0.21875 0.323242 0.876339 0.323242 1.6875C0.323242 2.49866 0.980831 3.15625 1.79199 3.15625V0.21875ZM3.75033 3.15625C4.56149 3.15625 5.21908 2.49866 5.21908 1.6875C5.21908 0.876339 4.56149 0.21875 3.75033 0.21875V3.15625ZM1.79199 10.0104C0.980831 10.0104 0.323242 10.668 0.323242 11.4792C0.323242 12.2903 0.980831 12.9479 1.79199 12.9479V10.0104ZM3.75033 12.9479C4.56149 12.9479 5.21908 12.2903 5.21908 11.4792C5.21908 10.668 4.56149 10.0104 3.75033 10.0104V12.9479ZM1.79199 19.8021C0.980831 19.8021 0.323242 20.4597 0.323242 21.2708C0.323242 22.082 0.980831 22.7396 1.79199 22.7396V19.8021ZM3.75033 22.7396C4.56149 22.7396 5.21908 22.082 5.21908 21.2708C5.21908 20.4597 4.56149 19.8021 3.75033 19.8021V22.7396ZM9.62532 10.0104C8.81416 10.0104 8.15657 10.668 8.15657 11.4792C8.15657 12.2903 8.81416 12.9479 9.62532 12.9479V10.0104ZM29.2087 12.9479C30.0198 12.9479 30.6774 12.2903 30.6774 11.4792C30.6774 10.668 30.0198 10.0104 29.2087 10.0104V12.9479ZM9.62532 19.8021C8.81416 19.8021 8.15657 20.4597 8.15657 21.2708C8.15657 22.082 8.81416 22.7396 9.62532 22.7396V19.8021ZM29.2087 22.7396C30.0198 22.7396 30.6774 22.082 30.6774 21.2708C30.6774 20.4597 30.0198 19.8021 29.2087 19.8021V22.7396ZM9.62532 3.15625H29.2087V0.21875H9.62532V3.15625ZM1.79199 3.15625H3.75033V0.21875H1.79199V3.15625ZM1.79199 12.9479H3.75033V10.0104H1.79199V12.9479ZM1.79199 22.7396H3.75033V19.8021H1.79199V22.7396ZM9.62532 12.9479H29.2087V10.0104H9.62532V12.9479ZM9.62532 22.7396H29.2087V19.8021H9.62532V22.7396Z" fill="white" />
                                                    </svg>
                                                </span>
                                                <span className={`crse-vdo-list-cross transition-all duration-300 ease-in-out transform absolute top-1/2 left-0 -translate-y-1/2 ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'}`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 42 42" fill="none">
                                                        <path d="M17.5531 15.6969C17.0405 15.1844 16.2095 15.1844 15.6969 15.6969C15.1844 16.2095 15.1844 17.0405 15.6969 17.5531L19.1438 21L15.697 24.447C15.1844 24.9594 15.1844 25.7905 15.697 26.3031C16.2095 26.8156 17.0406 26.8156 17.5531 26.3031L21 22.8563L24.4468 26.3031C24.9594 26.8156 25.7905 26.8156 26.3031 26.3031C26.8156 25.7905 26.8156 24.9594 26.3031 24.4468L22.8561 21L26.3031 17.5531C26.8156 17.0406 26.8156 16.2095 26.3031 15.697C25.7905 15.1844 24.9594 15.1844 24.4468 15.697L21 19.1438L17.5531 15.6969Z" fill="#BBB8B8" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M21 2.1875C10.6101 2.1875 2.1875 10.6101 2.1875 21C2.1875 31.3899 10.6101 39.8125 21 39.8125C31.3899 39.8125 39.8125 31.3899 39.8125 21C39.8125 10.6101 31.3899 2.1875 21 2.1875ZM4.8125 21C4.8125 12.0599 12.0599 4.8125 21 4.8125C29.9401 4.8125 37.1875 12.0599 37.1875 21C37.1875 29.9401 29.9401 37.1875 21 37.1875C12.0599 37.1875 4.8125 29.9401 4.8125 21Z" fill="#BBB8B8" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                        <div className={`crse-video-accordion transition-all duration-500 ease-in-out transform ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
                                            <form>
                                                <div className='crse-radio-list'>
                                                    {pedagogy.map((value, index) => (
                                                        <div className='crse-radio-sngl' key={index}>
                                                            <input
                                                                onChange={() => changePedagogy(index)}
                                                                type="radio"
                                                                id={`pedagogy-${index}`}
                                                                name="radio-group"
                                                                checked={selectedPedagogyIndex === index}
                                                            />
                                                            <label htmlFor={`pedagogy-${index}`} aria-label={value.title} tabIndex={0}>
                                                                <p className='crse-radio-ttl text-base text-white mb-1 font-normal'>{value.title}</p>
                                                                {value.pedagogy_type === 'ASSESSMENT' ? (
                                                                    <p className='crse-radio-time text-xs 2xl:text-sm text-white'>
                                                                        {value.pedagogy_type}
                                                                    </p>
                                                                ) : (
                                                                    <p className='crse-radio-time text-xs 2xl:text-sm text-white'>
                                                                        {`${Math.floor(value.time_in_sec / 60)} Min: ${value.time_in_sec % 60} Sec | ${value.pedagogy_type}`}
                                                                    </p>
                                                                )}

                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <Tabs>
                                    <div className='crse-video-tabs-wrap bg-[#E6E6E6] md:pt-5 pt-0 relative'>
                                        <div className='md:absolute md:right-3 pt-3 md:pt-0 pl-6 md:pl-0 md:top-1/2 md:-translate-y-1/2 w-[320px] 2xl:w-[430px] flex items-center' ref={feedbackRef}>
                                            <div className='video-action-row flex items-center mt-2 mb-1'>
                                                <div className='video-action-sngle mr-4'>
                                                    {/* Add selected class on click of button */}
                                                    <button onClick={() => addFeeback("likeness")} title='Like' className={`video-action-btn btn-like hover:-translate-y-1.5 transition duration-300 ${selectedFeedback === "likeness" ? "selected" : ""}`} aria-label='Like'>
                                                        <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.444 1.35396C11.6474 0.955692 10.6814 1.33507 10.3687 2.16892L7.807 9.00001L4 9.00001C2.34315 9.00001 1 10.3432 1 12V20C1 21.6569 2.34315 23 4 23H18.3737C19.7948 23 21.0208 22.003 21.3107 20.6119L22.9773 12.6119C23.3654 10.7489 21.9433 9.00001 20.0404 9.00001H14.8874L15.6259 6.7846C16.2554 4.89615 15.4005 2.8322 13.62 1.94198L12.444 1.35396ZM9.67966 9.70225L12.0463 3.39119L12.7256 3.73083C13.6158 4.17595 14.0433 5.20792 13.7285 6.15215L12.9901 8.36755C12.5584 9.66261 13.5223 11 14.8874 11H20.0404C20.6747 11 21.1487 11.583 21.0194 12.204L20.8535 13H17C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15H20.4369L20.0202 17H17C16.4477 17 16 17.4477 16 18C16 18.5523 16.4477 19 17 19H19.6035L19.3527 20.204C19.2561 20.6677 18.8474 21 18.3737 21H8V10.9907C8.75416 10.9179 9.40973 10.4221 9.67966 9.70225ZM6 11H4C3.44772 11 3 11.4477 3 12V20C3 20.5523 3.44772 21 4 21H6V11Z" fill="#0F0F0F" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className='video-action-sngle mr-4'>
                                                    <button onClick={() => addFeeback("dislikeness")} title='Dislike' className={`video-action-btn btn-dislike hover:-translate-y-1.5 transition duration-300 ${selectedFeedback === "dislikeness" ? "selected" : ""}`} aria-label='Dislike'>
                                                        <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.556 22.646C12.3525 23.0443 13.3186 22.6649 13.6313 21.8311L16.193 15L20 15C21.6568 15 23 13.6569 23 12L23 4C23 2.34315 21.6568 1 20 1L5.62625 1C4.20523 1 2.97914 1.99698 2.68931 3.38814L1.02265 11.3881C0.634535 13.2511 2.05665 15 3.95959 15H9.11255L8.37409 17.2154C7.7446 19.1039 8.59952 21.1678 10.38 22.058L11.556 22.646ZM14.3203 14.2978L11.9537 20.6088L11.2744 20.2692C10.3842 19.8241 9.95671 18.7921 10.2715 17.8479L11.0099 15.6325C11.4416 14.3374 10.4777 13 9.11256 13H3.95959C3.32527 13 2.85124 12.417 2.98061 11.7961L3.14645 11L6.99998 11C7.55226 11 7.99998 10.5523 7.99998 10C7.99998 9.44772 7.55226 9.00001 6.99998 9.00001L3.56312 9.00001L3.97978 7.00001L6.99998 7.00001C7.55226 7.00001 7.99998 6.55229 7.99998 6.00001C7.99998 5.44772 7.55226 5.00001 6.99998 5.00001L4.39645 5.00001L4.64727 3.79605C4.74388 3.33233 5.15258 3 5.62625 3L16 3L16 13.0093C15.2458 13.0821 14.5903 13.5779 14.3203 14.2978ZM18 13H20C20.5523 13 21 12.5523 21 12L21 4C21 3.44772 20.5523 3 20 3L18 3L18 13Z" fill="#0F0F0F" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className='video-action-sngle'>
                                                    <button className='video-action-btn btn-feedback hover:-translate-y-1.5 transition duration-300' title='Feedback' onClick={() => setShowFeedback((prev) => !prev)} aria-label='Feedback'>
                                                        <svg width="30px" height="30px" viewBox="2.5 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.0001 8.517C8.58589 8.517 8.2501 8.85279 8.2501 9.267C8.2501 9.68121 8.58589 10.017 9.0001 10.017V8.517ZM16.0001 10.017C16.4143 10.017 16.7501 9.68121 16.7501 9.267C16.7501 8.85279 16.4143 8.517 16.0001 8.517V10.017ZM9.8751 11.076C9.46089 11.076 9.1251 11.4118 9.1251 11.826C9.1251 12.2402 9.46089 12.576 9.8751 12.576V11.076ZM15.1251 12.576C15.5393 12.576 15.8751 12.2402 15.8751 11.826C15.8751 11.4118 15.5393 11.076 15.1251 11.076V12.576ZM9.1631 5V4.24998L9.15763 4.25002L9.1631 5ZM15.8381 5L15.8438 4.25H15.8381V5ZM19.5001 8.717L18.7501 8.71149V8.717H19.5001ZM19.5001 13.23H18.7501L18.7501 13.2355L19.5001 13.23ZM18.4384 15.8472L17.9042 15.3207L17.9042 15.3207L18.4384 15.8472ZM15.8371 16.947V17.697L15.8426 17.697L15.8371 16.947ZM9.1631 16.947V16.197C9.03469 16.197 8.90843 16.23 8.79641 16.2928L9.1631 16.947ZM5.5001 19H4.7501C4.7501 19.2662 4.89125 19.5125 5.12097 19.6471C5.35068 19.7817 5.63454 19.7844 5.86679 19.6542L5.5001 19ZM5.5001 8.717H6.25012L6.25008 8.71149L5.5001 8.717ZM6.56175 6.09984L6.02756 5.5734H6.02756L6.56175 6.09984ZM9.0001 10.017H16.0001V8.517H9.0001V10.017ZM9.8751 12.576H15.1251V11.076H9.8751V12.576ZM9.1631 5.75H15.8381V4.25H9.1631V5.75ZM15.8324 5.74998C17.4559 5.76225 18.762 7.08806 18.7501 8.71149L20.2501 8.72251C20.2681 6.2708 18.2955 4.26856 15.8438 4.25002L15.8324 5.74998ZM18.7501 8.717V13.23H20.2501V8.717H18.7501ZM18.7501 13.2355C18.7558 14.0153 18.4516 14.7653 17.9042 15.3207L18.9726 16.3736C19.7992 15.5348 20.2587 14.4021 20.2501 13.2245L18.7501 13.2355ZM17.9042 15.3207C17.3569 15.8761 16.6114 16.1913 15.8316 16.197L15.8426 17.697C17.0201 17.6884 18.1461 17.2124 18.9726 16.3736L17.9042 15.3207ZM15.8371 16.197H9.1631V17.697H15.8371V16.197ZM8.79641 16.2928L5.13341 18.3458L5.86679 19.6542L9.52979 17.6012L8.79641 16.2928ZM6.2501 19V8.717H4.7501V19H6.2501ZM6.25008 8.71149C6.24435 7.93175 6.54862 7.18167 7.09595 6.62627L6.02756 5.5734C5.20098 6.41216 4.74147 7.54494 4.75012 8.72251L6.25008 8.71149ZM7.09595 6.62627C7.64328 6.07088 8.38882 5.75566 9.16857 5.74998L9.15763 4.25002C7.98006 4.2586 6.85413 4.73464 6.02756 5.5734L7.09595 6.62627Z" fill="#0F0F0F" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            {showFeedback && (
                                                <div className="video-feedback mb-0 ml-3 2xl:w-[280px]">
                                                    <textarea name="feeback" value={feedback} onChange={handleFeedbackChange} className="inter-400 text-black text-xs border border-[#bbb] focus:border-[#B44D71] rounded-md h-12 outline-0 w-full py-1.5 px-1.5 transition duration-300"></textarea>
                                                    <button onClick={() => addFeeback("feedback")} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-4 h-6 2xl:h-7 text-white inter-500 text-xs rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label='Submit'>Submit</button>
                                                </div>
                                            )}
                                        </div>
                                        <div className='crse-video-tabs-row lg:w-3/5 mx-auto px-6 lg:px-0'>
                                            <TabList>
                                                <Tab aria-label="Overview">
                                                    <div className='flex items-center'>
                                                        <span className='crse-video-tab-icon mr-3 w-10'>
                                                            <img src='../images/video-overview.svg' alt='overview' />
                                                        </span>
                                                        <span className='crse-video-tab-name text-lg text-black'>
                                                            Overview
                                                        </span>
                                                    </div>
                                                </Tab>
                                                <Tab aria-label="Take Note">
                                                    <div className='flex items-center'>
                                                        <span className='crse-video-tab-icon mr-3 w-10'>
                                                            <img src='../images/video-notes.svg' alt='note' />
                                                        </span>
                                                        <span className='crse-video-tab-name text-lg text-black'>
                                                            Take Notes
                                                        </span>
                                                    </div>
                                                </Tab>
                                                <Tab aria-label="Transcript">
                                                    <div className='flex items-center'>
                                                        <span className='crse-video-tab-icon mr-3 w-10'>
                                                            <img src='../images/video-transcript.svg' alt='transcript' />
                                                        </span>
                                                        <span className='crse-video-tab-name text-lg text-black'>
                                                            Transcript
                                                        </span>
                                                    </div>
                                                </Tab>
                                            </TabList>
                                        </div>
                                    </div>
                                    <div className='crse-video-tabs-panel-wrap py-10 px-6 lg:px-0'>
                                        <div className='crse-video-tabs-panel-box lg:w-3/5 mx-auto'>
                                            <TabPanel>
                                                <div className='crse-video-cntnt-ovrw'>
                                                    <h3 className='text-xl font-bold text-black mb-1'>{selectedPedagogy.title}</h3>
                                                    <p className='text-base font-normal text-[#716F6F] mb-3'>
                                                        {`${Math.floor((selectedPedagogy?.time_in_sec ?? 0) / 60)} Min: ${(selectedPedagogy?.time_in_sec ?? 0) % 60} Sec . | . ${selectedPedagogy?.level} . | . Published on ${getDateText(selectedPedagogy?.updated)}`}

                                                    </p>
                                                    <p className='text-lg font-normal text-black mb-4'>{selectedPedagogy.text}</p>
                                                    <h4 className='text-base font-bold text-black mb-4'>Topics Covered</h4>
                                                    <div className='vdo-topic-btns flex items-center md:gap-6 gap-4 lg:gap-10'>
                                                        {/* <div className='vdo-topic-btn-sngl text-base text-black border border-black bg-white rounded-3xl py-2 px-5 highlighted'>Photons</div> */}
                                                        {topics.map((value, index) => (
                                                            <div key={index} className='vdo-topic-btn-sngl text-base text-black border border-black bg-white rounded-3xl py-2 px-5'>{value}</div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className='crse-video-cntnt-note'>
                                                    <h3 className='text-xl font-bold text-black mb-1'>{notes.length} Notes Saved</h3>
                                                    <Tabs>
                                                        <div className='crse-note-tabs mb-6'>
                                                            <TabList>
                                                                {notes.map((value, index) => (
                                                                    <Tab key={value.id}>Note {index}</Tab>
                                                                ))}
                                                            </TabList>
                                                        </div>
                                                        <div className='crse-note-cntnt'>
                                                            {notes.map((value, index) => (
                                                                <TabPanel key={value.id}>
                                                                    <div className='crse-note-old'>
                                                                        <p className='crse-note-old-text text-base 2xl:text-lg text-black'>{value.notes}</p>
                                                                    </div>
                                                                </TabPanel>
                                                            ))}

                                                        </div>
                                                    </Tabs>
                                                    <div className='crse-new-note-btn mt-8 pt-8 border-t border-[#D0D0D0]'>

                                                        <div className='crse-take-note-area'>
                                                            <form>
                                                                <div className='crse-note-field mb-8'>
                                                                    <textarea name='notes' placeholder='Take new note' value={selectedNote.notes} onChange={handleValueChange} className='text-base border border-black p-3 w-full h-36 resize-none'></textarea>
                                                                </div>
                                                                <buton type="button" onClick={() => addNote()} className='w-full md:w-max cursor-pointer bg-tertiary hover:bg-black flex items-center justify-center px-8 h-10 2xl:h-16 text-white inter-600 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Save Note</buton>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className='crse-video-cntnt-ovrw'>
                                                    {transcript.length > 0 && (
                                                        <ul className="mt-4 space-y-2">
                                                            {transcript.map((sub, i) => (
                                                                <li key={i} className="flex justify-between items-center bg-gray-100 p-2 rounded">
                                                                    <span>Transcript:</span>
                                                                    <button
                                                                        className="bg-green-600 text-white px-3 py-1 rounded"
                                                                        onClick={() => downloadSubtitle(sub.link, sub.language, i)}
                                                                    >
                                                                        Download
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </Tabs>
                            </div>
                        </div>

                        <div className='lg:py-10 md:py-8 py-0 lg:px-12 px-6 course-navigate-btns flex flex-wrap justify-between'>
                            <a href='#' onClick={(e) => {e.preventDefault(); changeModule("prev")}} className='w-full md:w-max mb-4 md:mb-0 cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label="Previous Lesson" tabIndex={0}>Previous Lesson</a>
                            <a href='#' onClick={(e) => {e.preventDefault(); changeModule("next")}} className='w-full md:w-max cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label="Next Lesson" tabIndex={0}>Next Lesson</a>
                        </div>
                    </div>
                )}
            </div>
            {/* In chat-bbl-text we need to add class "active-chat" on click chat bubble */}
            <div className={shakeActive ? 'chat-bbl-text fixed bottom-7 right-24 z-50' : 'chat-bbl-text fixed bottom-7 right-24 z-50'}>
                <p className='text-xs inter-500 text-white bg-[#620b57] py-3 px-3 rounded-md relative'>
                    Ask Me Anything
                </p>
            </div>
            <df-messenger
                project-id="qlitex"
                agent-id="5e294f2b-c5c9-49a4-9170-20db654a8460"
                language-code="en"
                max-query-length="-1"
                allow-feedback="all">
                <df-messenger-chat-bubble
                    chat-title="Q-Bot" chat-icon="https://storage.googleapis.com/q-lite/Icon-01.svg" chat-title-icon="https://storage.googleapis.com/mediajenie/QLITE_Logo-01.svg">
                </df-messenger-chat-bubble>
            </df-messenger>
            {popupVisible && <SurveyPopup onClose={handleClose} questions={allSurvey} />}

        </>
    );
}